export const environment = {
  "appId": "wise-pelican-pro-v2",
  "backendUrl": "",
  "production": true,
  "wsUrl": "",
  "CHILI_EDITOR_URL": "https://cp-lbc-925.chili-publish.online",
  "FACEBOOK_APP_ID": "583177669153772",
  "GOOGLE_MAPS_KEY": "AIzaSyBheX9OmQDLPGFPaUfItaskjtzWxj_rQF0",
  "HUBSPOT_CHAT_URL": "//js-na1.hs-scripts.com/20264405.js",
  "HUBSPOT_FORM_ID": "54833736-5003-453d-af5c-e4343389eb1a",
  "HUBSPOT_PORTAL_ID": "20264405",
  "POSTHOG_PROJECT_KEY": "phc_d6t3af1LyHDKhm5LWtg6gKp42rUkuqhzXK9xxgHiHvP",
  "SENTRY_DSN": "https://cf3db79bca934d90a5fe7e018cff32f2@o251260.ingest.us.sentry.io/1437281",
  "STRIPE_PUBLIC_KEY": "pk_live_BxM3JHWq8IkMOvzlFrpeM9yb",
  "USERPILOT_TOKEN": "NX-8bf11f2a"
}